import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-159">
      <FadeIn data-id="element-160">
        <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[28px]" data-id="element-161">
          El próximo domingo puede ser diferente. 🥗
        </h2>

        <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-162">
          {/* Option 1 */}
          <a href="https://www.tumanualdigital.com/cart/44024762368036:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gray-900 border border-gray-700 rounded-2xl hover:border-gray-500 transition-colors group pt-[0px] pb-[0px]" data-id="element-163">
            <div className="text-left mb-4 sm:mb-0" data-id="element-164">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-165">
                <span data-id="element-166">📘</span> MEGAPACK NUTRICIONISTA LISTA
              </h3>
              <div className="flex items-center gap-3 mt-1" data-id="element-167">
                <span className="text-red-400 line-through text-sm" data-id="element-168">
                  $95.000
                </span>
                <span className="text-2xl font-black text-white" data-id="element-169">
                  $19.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-gray-800 text-white font-bold py-3 px-6 rounded-xl group-hover:bg-gray-700 transition-colors w-full sm:w-auto text-center" data-id="element-170">
              → QUIERO MI MEGAPACK
            </div>
          </a>

          {/* Option 2 */}
          <a href="https://www.tumanualdigital.com/cart/44024763645988:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-green-900/40 to-gray-900 border-2 border-green-500 rounded-2xl hover:shadow-[0_0_30px_rgba(34,197,94,0.2)] transition-all group relative overflow-hidden" data-id="element-171">
            <div className="absolute top-0 right-0 bg-green-500 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-172">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-173">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-174">
                <span data-id="element-175">🏆</span> MEGAPACK + CEREBRO DIGITAL
              </h3>
              <div className="flex items-center gap-3 mt-1" data-id="element-176">
                <span className="text-red-400 line-through text-sm" data-id="element-177">
                  $130.000
                </span>
                <span className="text-2xl font-black text-green-400" data-id="element-178">
                  $27.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-green-500 text-black font-bold py-3 px-6 rounded-xl group-hover:bg-green-400 transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-179">
              → QUIERO EL MEGAPACK + CEREBRO DIGITAL
            </div>
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-400 font-medium" data-id="element-180">
          <span className="flex items-center gap-1.5" data-id="element-181">
            <Lock size={16} className="text-green-500" data-id="element-182" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-183">
            <Zap size={16} className="text-yellow-400" data-id="element-184" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-185">
            <Shield size={16} className="text-green-500" data-id="element-186" /> Garantía 7 días
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-gray-500" data-id="element-187">
          <span className="flex items-center gap-1.5" data-id="element-188">
            <CreditCard size={16} data-id="element-189" /> Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </FadeIn>
    </section>;
}